import {
  FETCH_EMAIL_STATS,
  FETCH_EMAIL_EVENTS,
  FETCH_EMAIL_TIMELINE,
  FETCH_EMAIL_SUBJECTS,
  FETCH_CAMPAIGN_STATS,
  FETCH_SEQUENCE_STATS,
  FETCH_SEQUENCE_USERS,
  EMAIL_ANALYTICS_ERROR,
  EMAIL_ANALYTICS_LOADING,
  CLEAR_EMAIL_ANALYTICS,
} from "../actions/types";

const initialState = {
  stats: null,
  events: {
    events: [],
    total: 0,
    page: 1,
    limit: 50,
    totalPages: 0,
  },
  timeline: {
    data: [],
    startDate: null,
    endDate: null,
    groupBy: "day",
  },
  campaigns: {
    campaigns: [],
    startDate: null,
    endDate: null,
  },
  sequence: {
    totalUsers: 0,
    activeSequences: 0,
    completedAll: 0,
    pendingNow: 0,
    byDay: [],
    averageCompletion: 0,
  },
  sequenceUsers: {
    users: [],
    total: 0,
    page: 1,
    limit: 50,
    totalPages: 0,
  },
  subjects: [],
  loading: {
    stats: false,
    events: false,
    timeline: false,
    campaigns: false,
    sequence: false,
    sequenceUsers: false,
  },
  error: null,
};

export default function emailAnalyticsReducer(state = initialState, action) {
  switch (action.type) {
    case EMAIL_ANALYTICS_LOADING:
      return {
        ...state,
        loading: {
          ...state.loading,
          ...action.payload,
        },
        error: null,
      };

    case FETCH_EMAIL_STATS:
      return {
        ...state,
        stats: action.payload,
        loading: {
          ...state.loading,
          stats: false,
        },
      };

    case FETCH_EMAIL_EVENTS:
      return {
        ...state,
        events: action.payload,
        loading: {
          ...state.loading,
          events: false,
        },
      };

    case FETCH_EMAIL_TIMELINE:
      return {
        ...state,
        timeline: action.payload,
        loading: {
          ...state.loading,
          timeline: false,
        },
      };

    case FETCH_EMAIL_SUBJECTS:
      return {
        ...state,
        subjects: action.payload,
      };

    case FETCH_CAMPAIGN_STATS:
      return {
        ...state,
        campaigns: {
          campaigns: action.payload.campaigns,
          startDate: action.payload.startDate,
          endDate: action.payload.endDate,
        },
        loading: {
          ...state.loading,
          campaigns: false,
        },
      };

    case FETCH_SEQUENCE_STATS:
      return {
        ...state,
        sequence: action.payload,
        loading: {
          ...state.loading,
          sequence: false,
        },
      };

    case FETCH_SEQUENCE_USERS:
      return {
        ...state,
        sequenceUsers: action.payload,
        loading: {
          ...state.loading,
          sequenceUsers: false,
        },
      };

    case EMAIL_ANALYTICS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: {
          stats: false,
          events: false,
          timeline: false,
          campaigns: false,
          sequence: false,
          sequenceUsers: false,
        },
      };

    case CLEAR_EMAIL_ANALYTICS:
      return initialState;

    default:
      return state;
  }
}
